var map = {
	"./gameUpdatesService.js": 31,
	"./gameUpdatesUtility.js": 32,
	"./layoutLibraryI18nService.js": 33,
	"./notificationStreamService.js": 34,
	"./notificationStreamUtility.js": 35
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;